// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".basic-cards[data-v-04a4d64a]{display:inline-flex;grid-gap:24px;gap:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
